<template>
  <div>    
    <CCard>
      <CCardBody>
        <div v-html="this.html" />
      </CCardBody>      
    </CCard>
  </div>
</template>

<script>

import IndexServices from "@/services/Index";
import utilServices from "@/services/Util";
import settings from "@/settings";

export default {
  name: 'Inicio',

  components: {
    
  },  

  data () {
    return {
      html: ""
    }
  },

  mounted: function() {
    settings.usuarioAutenticado = JSON.parse(localStorage.getItem("user_sysped"));

    if (settings.usuarioAutenticado != null) {
      IndexServices.get().then(
        (response) => {        
          this.html = response.data;
        },
        (error) => {
          utilServices.parseServerError(error, this);
        }
      );
    }
  },

  methods: {
    
  }
}
</script>
